angular.module('galilai.creator').controller('LayoutController', function ($scope, $http, $timeout, visual, layoutService, api, parserService, $rootScope, fontsService) {

    const IMAGE_SIZE = 'large2x'
    const PLACEHOLDER_IMAGE = '/assets/images/creator/placeholder.png'
    const VISUAL_ENABLED = true
    const DYNAMIC_TEMPLATES_FOR_EVERYONE = true
    const INITIAL_LAYOUT_TAB = 'default' // explore, user, children

    // On mobile page size is only 10
    const PAGINATION_SIZE = window.innerWidth < 768 ? 4 : 10

    $scope.availableLayouts = []
    $scope.overlaysConfig = null
    $scope.selectedItem = null
    $scope.tmpEditingItem = null
    $scope.tmpEditing = null
    $scope.visual = null
    $scope.currentProject = null
    $scope.mode = $rootScope.lastLayoutTab || 'layouts'
    $scope.alreadyOpenedEdit = false
    $scope.detachedSelection = null

    $scope.$watch('mode', function(newValue, oldValue) {
        $rootScope.lastLayoutTab = newValue
    })

    $rootScope.$on('reloadUserLayouts', function(event, args) {
        $scope.changeLayoutTab('user')
    })

    $rootScope.$on('onUserData', function(event, args) {
        if (args.features && args.features.dynamic_templates || DYNAMIC_TEMPLATES_FOR_EVERYONE) {
            $scope.state.view.dynamicTemplates = true
            $scope.state.view.layoutTab = INITIAL_LAYOUT_TAB
        }
        if (args.features && (args.features.import_templates_advanced || args.features.import_templates)) {
            $scope.state.view.importTemplates = true
        }
        if (args.features && args.features.import_templates_advanced) {
            $scope.state.view.advancedImport = true
        }
    })

    $scope.smartFiltersMap = {
        grid: ['vertical', 'horizontal'],
        style: ['geometric', 'rounded'],
        shader: ['flat', '3d'],
        orientation: ['begin', 'end'],
        focus: ['text', 'balanced', 'fullscreen'],
        //alignment: ['left', 'center', 'right'],
        decorative: ['no', 'yes'],
        include_shapes: ['no', 'yes'],
    }

    $scope.smartFilters = {
        inputs: [
        ],
        values: {
        }
    }

    function buildSmartFilters() {
        if (!safeGetStorage('layouts.seed')) {
            safeSetStorage('layouts.seed', Math.floor(Math.random() * 1000000))
        }
        for (let key in $scope.smartFiltersMap) {
            let values = $scope.smartFiltersMap[key]
            let filter = {
                label: gettext('layout.smart_title_' + key),
                id: key,
                values: [
                    {
                        label: gettext('layout.smart_any'),
                        value: 'any'
                    }
                ]
            }
            values.forEach(function(value) {
                filter.values.push({
                    label: gettext('layout.smart_'+ value),
                    value: value
                })
            })
            $scope.smartFilters.inputs.push(filter)
            $scope.smartFilters.values[key] = 'any'
        }
    }

    $scope.refreshSmartLayouts = function() {
        safeSetStorage('layouts.seed', Math.floor(Math.random() * 1000000))
        $scope.changeLayouts()
    }

    buildSmartFilters()

    $scope.search = {
        images: 'social media',
        icons: ''
    }
    $scope.state = {
        view: {
            editMode: 'multiple',
            currentLayoutParentId: null,
            layouts: [],
            importTemplates: true,
            dynamicTemplates: false,
            selectedElement: false,
            visualEnabled: VISUAL_ENABLED,
            backgroundEnabled: false,
            iconLoading: false,
            imageTab: 'pexels',
            layoutTab: 'default',
            category: 'question',
            noLayoutAvailable: false,
            layers: [],
            showLayers: false,
            loadingMore: false,
            pagination: {
                page: 1,
                hasMore: false,
                limit: PAGINATION_SIZE
            },
            selection: {
                fonts: false,
                images: false,
            },
            content: {
                tab: 'text',
                types: [
                    {
                        name: gettext('label.import_tabs_text'),
                        value: 'text'
                    },
                    {
                        name: gettext('label.import_tabs_image'),
                        value: 'image'
                    },
                ],
            },
            visualMode: null,
            visual: {
                border: false,
                frame: false,
            }
        },
        layoutFilter: {
            available: {},
            selected: {
                objective: 'cover'
            },
            selectedUser: {
            },
        },
        combinations: {
            fonts: [],
            images: [],
        },
        data: {
            fonts: JSON.parse(JSON.stringify(DEFAULT_FONTS)),
        },
        images: {
            pexels: []
        }
    }
    $scope.favorites = {
        layouts: [],
        map: {},
    }
    $scope.images = []
    $scope.medias = []

    $scope.availableCategories = [
        'all',
        'question',
        'trivia',
        'number',
        'images',
        'social',
        'news',
        'checklist',
        'quote',
        'cover',
        'slide',
        //'before-after',
    ]

    $scope.noFilterCategories = [
        'question',
        'trivia',
    ]

    $scope.suggestedSearchIcons = [
        {
            value: gettext('icons.suggested.phone'),
        },
        {
            value: gettext('icons.suggested.arrow'),
        },
        {
            value: gettext('icons.suggested.heart'),
        },
        {
            value: gettext('icons.suggested.bubble'),
        },
        {
            value: gettext('icons.suggested.shopping'),
        },
        {
            value: gettext('icons.suggested.local'),
        },
        {
            value: gettext('icons.suggested.star'),
        },
    ]

    $scope.availableTags = [
        {
            'id': 'base',
            'active': true,
            'label': gettext('tags.base'),
        },
        // Points
        {
            'id': 'points',
            'active': false,
            'label': gettext('tags.points'),
        },
        // Circles
        {
            'id': 'circles',
            'active': false,
            'label': gettext('tags.circles'),
        },
        // blob
        {
            'id': 'blob',
            'active': false,
            'label': gettext('tags.blob'),
        },
        // waves
        {
            'id': 'waves',
            'active': false,
            'label': gettext('tags.waves'),
        },
        // Corner
        {
            'id': 'corner',
            'active': false,
            'label': gettext('tags.corner'),
        },
        // lines
        {
            'id': 'lines',
            'active': false,
            'label': gettext('tags.lines'),
        },
        // swipe
        {
            'id': 'swipe',
            'active': false,
            'mix': true,
            'label': gettext('tags.swipe'),
        },
        {
            'id': 'all',
            'active': false,
            'label': gettext('tags.all'),
        },
    ]

    function initializeSetting(id) {
        if (!$scope.selectedItem.theme.settings) {
            $scope.selectedItem.theme.settings = {}
        }
        if (!$scope.selectedItem.theme.settings[id]) {
            $scope.selectedItem.theme.settings[id] = {}
        }
        if (!$scope.selectedItem.theme.defaults) {
            $scope.selectedItem.theme.defaults = {}
        }
    }

    $scope.getCategoryName = function(category) {
        return gettext('category.' + category)
    }

    $scope.showAllTags = function() {
        $scope.toggleTag($scope.availableTags.filter(function(tag) {
            return tag.id == 'all'
        })[0])
    }

    $scope.toggleTag = function(tag) {

        // Add loading
        if (tag.id == 'all') {
            // Activate all
            $scope.availableTags.forEach(function(tag) {
                tag.active = tag.id == 'all'
                return tag
            })
            return
        }

        let isAllActive = $scope.availableTags.filter(function(tag) {
            return tag.id == 'all' && tag.active
        }).length > 0

        if (isAllActive) {
            $scope.availableTags.forEach(function(tag) {
                tag.active = false
            })
        }

        $scope.availableTags.forEach(function(t) {
            if (t.id == tag.id) {
                return
            }
            if (tag.mix) {
                return
            }
            if (t.id != 'all' && (typeof t.mix == 'undefined' || !t.mix)) {
                t.active = false
            }
        })

        tag.active = !tag.active
        // If not tag is active, activate all
        let hasActive = $scope.availableTags.filter(function(tag) {
            return tag.active
        }).length > 0

        if (!hasActive) {
            $scope.availableTags.forEach(function(tag) {
                tag.active = tag.id == 'all'
                return tag
            })
        }

        track('Editor Toggle Tag', {
            tag: tag.id,
            active: tag.active
        })
    }


    function updateVisibleLayouts() {
        $scope.updateAvailableLayouts()
    }

    $scope.$watch('state.view.category', updateVisibleLayouts)
    $scope.$watch('availableTags', updateVisibleLayouts, true)

    let debounceUpdateLayoutsTimer = null
    const debounceUpdateLayoutsTimeout = window.innerWidth < 768 ? 300 : 200
    $scope.updateAvailableLayouts = function() {
        $scope.state.view.loadingLayouts = true
        if (debounceUpdateLayoutsTimer) {
            $timeout.cancel(debounceUpdateLayoutsTimer)
        }
        debounceUpdateLayoutsTimer = $timeout(function() {
            $scope.renderLayouts()

            $timeout(function() {
                let hasElements =  document.getElementById('templates-wrapper').offsetHeight > 0
                let hasSelectedTags = $scope.availableTags.filter(function(tag) {
                    return tag.active && (tag.id != 'all' && tag.id != 'base')
                }).length > 0

                $scope.state.view.noLayoutAvailable = !hasElements && hasSelectedTags
                debounceUpdateLayoutsTimer = null
                $scope.state.view.loadingLayouts = false
            })
        }, debounceUpdateLayoutsTimeout)
    }

    $scope.loadTempEditingItem = function() {
        $scope.tmpEditingItem = fullcopy($scope.selectedItem)

        $scope.tmpEditing = {
            fontSize: {}
        }

        const DEFAULTS = getBaseTheme().defaults
        const baseTheme = fullcopy($scope.selectedItem.theme)
        if (!$scope.selectedItem.theme.defaults) {
            $scope.selectedItem.theme.defaults = {}
        }
        if ($scope.state.view.editMode == 'multiple') {
            const base = fullcopy($scope.selectedItem.theme.defaults)
            $scope.tmpEditing.fontSize = Object.assign({}, DEFAULTS, base)
            $scope.tmpEditing.pallete = Object.assign({}, baseTheme.pallete)
        } else {
            const defaults = fullcopy($scope.selectedItem.theme.defaults)
            const base = fullcopy($scope.selectedItem.theme.settings[$scope.selectedItem.id]) || {}
            $scope.tmpEditing.fontSize = Object.assign({}, DEFAULTS, defaults, base)
            $scope.tmpEditing.pallete = Object.assign({}, baseTheme.pallete, base.pallete)
        }
    }

    $scope.renderSinglePreview = function() {
        let availableLayouts = []
        let newTheme = fullcopy($scope.selectedItem.theme);
        if ($scope.state.view.pagination.page == 1) {
            availableLayouts.push(convertLayout($scope.selectedItem.layout, $scope.selectedItem.item, newTheme))
        }
        $scope.availableLayouts = availableLayouts
    }

    $scope.onChangeFontSize = function(kind) {
        if ($scope.mode != 'font-size') {
            return
        }
        let editedSettings = $scope.tmpEditing.fontSize
        initializeSetting($scope.tmpEditingItem.id)
        if ($scope.state.view.editMode == 'multiple') {
            $scope.selectedItem.theme.defaults[kind] = editedSettings[kind]
        } else {
            $scope.selectedItem.theme.settings[$scope.selectedItem.id][kind] = editedSettings[kind]
        }
        $scope.changeSettings()
        $scope.renderSinglePreview()
        $timeout(angular.noop)
    }

    $scope.resetToDefault = function(kind) {
        initializeSetting($scope.tmpEditingItem.id)

        if ($scope.mode == 'font-size') {
            const DEFAULTS = getBaseTheme().defaults
            if ($scope.state.view.editMode == 'multiple') {
                $scope.selectedItem.theme.defaults = Object.assign({}, DEFAULTS)
            } else {
                let keysToRemove = ['titleSize', 'descriptionSize', 'titleMinSize', 'descriptionMinSize']
                keysToRemove.forEach(function(key) {
                    if ($scope.selectedItem.theme.settings[$scope.selectedItem.id] && $scope.selectedItem.theme.settings[$scope.selectedItem.id][key]) {
                        delete $scope.selectedItem.theme.settings[$scope.selectedItem.id][key]
                    }
                })
            }
            $scope.changeSettings()
            $scope.renderSinglePreview()
        }
        $scope.loadTempEditingItem()
        $timeout(angular.noop)
    }

    $scope.saveToBranding = function() {
        let fields = ['defaults']

        api.updateTheme({
            defaults: $scope.tmpEditing.fontSize,
        }, $scope.currentProject._id, fields)
        .then(function() {
            showSuccess(gettext('label.success_generic'))
        })
        .catch(function() {
            showError(gettext('error.generic'))
        })
    }

    $scope.applyToAllPages = function() {

    }

    $rootScope.$on('chooseLayout', function(event, data) {
        if (data.source) {
            $scope.detachedSelection = {
                source: data.source
            }
        }
        let layoutsModal = angular.element('#layouts-modal')
        layoutsModal.modal('show', {
            backdrop: 'static',
            keyboard: false
        })
        $scope.selectedItem = data
        $scope.state.view.projectId = data.projectId
        if (data.kind == 'layout-canva') {
            $scope.state.view.layoutTab = 'user'
        }
        $scope.changeLayouts()
    })

    $rootScope.$on('editItem', function(event, data) {
        if (data.params && data.params.mode) {
            $scope.state.view.editMode = data.params.mode
        } else {
            $scope.state.view.editMode = 'multiple'
        }

        $scope.selectedItem = data
        $scope.loadTempEditingItem()

        if ($scope.selectedItem.theme) {
            if (!$scope.selectedItem.theme.global) {
                $scope.selectedItem.theme.global = {}
            }
            $scope.selectedItem.theme.global.applyRotation = true
        }
        if (!$scope.alreadyOpenedEdit && $scope.shouldShowContentTab()) {
            $scope.mode = 'content'
            $scope.alreadyOpenedEdit = true
        }
        let mapAction = {
            'layout': $scope.changeLayouts,
            'pallete': $scope.changePallete,
            'fonts': $scope.changeFonts,
            'sizes': $scope.changeSizes,
            'visual': $scope.changeVisual,
            'backgrounds': $scope.changeBackgrounds,
            'images': $scope.changeImages,
            'icons': $scope.changeIcons,
            'content': $scope.changeContent,
        }
        if (data.kind && mapAction[data.kind]) {
            $scope.mode = data.kind
        }
        if ($scope.mode == 'content' && !$scope.shouldShowContentTab()) {
            $scope.mode = 'layout'
        }
        if (mapAction[$scope.mode]) {
            mapAction[$scope.mode]()
        } else {
            $scope.mode = 'layout'
            $scope.changeLayouts()
        }

        if (data.params && data.params.dynamicId) {
            $scope.state.view.currentLayoutParentId = data.params.dynamicId
        }
        // In use layouts
        $scope.state.view.layoutsInUse = []
        if (data.params && data.params.layouts) {
            $scope.state.view.layoutsInUse = data.params.layouts
        }

        if (data.params && data.params.projectId) {
            $scope.state.view.projectId = data.params.projectId
        }

        if (data.params && data.params.project) {
            $scope.currentProject = data.params.project
        }

        if (data.id == 0) {
            $scope.state.layoutFilter.selected.objective = 'cover'
        }
        else if (data.id > 0) {
            $scope.state.layoutFilter.selected.objective = 'page_item'
        }
        $scope.getFavorites()
        $timeout(angular.noop)
    })

    $scope.getCategories = function() {
        api.getImporterCategories().then(function(res) {
            function convertValues(item) {
                let row = {
                    value: item.key,
                    label: item.name,
                }
                return row
            }
            let data = res.data
            data.areas = data.areas.map(convertValues)
            data.categories = data.categories.map(convertValues)
            data.professions = data.professions.map(convertValues)
            data.objectives = data.objectives.map(convertValues)

            let availableObjectives = [
                'cover', 'page_item', 'services',
            ]
            data.objectives = data.objectives.filter(function(objective) {
                return availableObjectives.indexOf(objective.value) != -1
            })
            $scope.state.layoutFilter.available = data
            $timeout(angular.noop)
        })
        .catch(function() {

        })
    }

    $scope.fontFamilies = ALL_GOOGLE_FONTS;
    $scope.showCustomFont = false
    $scope.showFontSelection = false

    // LATER - Duplicated
    function convertLayout(layout, item, theme) {
        return parserService.convertLayout(layout,
            item,
            parserService.getThemeForItem(theme, item, $scope.selectedItem.id)
        )
    }

    $scope.isDynamic = function() {
        return typeof $scope.state.view.currentLayoutParentId != 'undefined' && $scope.state.view.currentLayoutParentId != null
    }

    $scope.loadLayoutChildren = function(layout) {
        $scope.state.view.currentLayoutParentId = null
        let parentId = getLayoutParentId(layout)
        if (!parentId) {
            return
        }
        $scope.state.view.currentLayoutParentId = parentId

        $rootScope.$broadcast('loadLayoutChildren', {
            layout: {
                label: layout.label,
            }
        })
    }

    $scope.showImport = function(id, params) {
        let importModal = angular.element('#import-modal')
        importModal.modal('show', {
            backdrop: 'static',
            keyboard: false
        })

        $rootScope.$broadcast('getCurrentPost', {
            kind: 'showImport',
            id: id,
            params: params,
        })
    }

    $rootScope.$on('currentPost', function(event, data) {
        if (data.data.kind != 'showImport') {
            return
        }
        let post = data.post
        let projectId = null
        if (post?.meta?.project) {
            projectId = post.meta.project
        } else {
            projectId = $scope.state.view.projectId
        }
        let params = {
            projectId: projectId
        }
        if (data.data.id) {
            params.id = data.data.id
        }
        if (data.data.params) {
            params = Object.assign(params, data.data.params)
        }
        $rootScope.$emit('openImport', params)
    })

    $scope.editTemplate = function($index) {
        let id = getLayoutParentId($scope.availableLayouts[$index])
        if (!id) {
            return
        }
        $scope.showImport(id)
    }

    $scope.duplicateTemplate = function($index) {
        let id = getLayoutParentId($scope.availableLayouts[$index])
        if (!id) {
            return
        }
        $scope.showImport(id, {
            duplicate: true
        })
    }

    $scope.importAsStyle = function($index) {
        let id = getLayoutParentId($scope.availableLayouts[$index])
        if (!id) {
            return
        }
        $scope.showImport(id, {
            style: true
        })
    }

    function publishTemplate($index, status) {
        let label = $scope.availableLayouts[$index].label
        if (!label) {
            return
        }
        api.publishLayout({
            label: label,
            public: status
        })
        .then(function() {
            showSuccess(gettext('label.success_generic'))
        })
        .catch(function() {
            showError(gettext('error.generic'))
        })
    }
    $scope.publishTemplate = function($index) {
        publishTemplate($index, true)
    }

    $scope.unpublishTemplate = function($index) {
        publishTemplate($index, false)
    }

    $scope.onSmartFiltersChange = function() {
        $scope.changeLayouts()
    }
    $scope.changeLayouts = function() {
        $scope.mode = 'layout'
        let newItem = fullcopy($scope.selectedItem.item)
        $scope.resetPagination()

        let params = {
            kind: null,
        }
        let filtered = []
        if ($scope.state.view.layoutTab == 'explore') {
            params.kind = 'explore'
        } else if ($scope.state.view.layoutTab == 'smart') {
            params.kind = 'smart'
            params.filters = $scope.smartFilters.values
            params.inputs = $scope.selectedItem.item
        } else if ($scope.state.view.layoutTab == 'templates') {
            params.kind = 'templates'
            params.inputs = $scope.selectedItem.item
        } else if ($scope.state.view.layoutTab == 'user') {
            params.kind = 'user'
        } else if ($scope.state.view.layoutTab == 'children') {
            params.kind = 'children'
            params.parentId = $scope.state.view.currentLayoutParentId
        } else if ($scope.state.view.layoutTab == 'favorite') {
            params.kind = 'favorite'
        } else if ($scope.state.view.layoutTab == 'in-use') {
            filtered = $scope.state.view.layoutsInUse || ['_']
        }

        if ($scope.state.view.layoutTab == 'explore') {
            params.filter = $scope.state.layoutFilter.selected
        } else if ($scope.state.view.layoutTab == 'user') {
            params.filter = $scope.state.layoutFilter.selectedUser
        } else if ($scope.state.view.layoutTab == 'favorite') {
            params.projectId = $scope.state.view.projectId
        }

        newItem.overlays = {elements: []}

        $scope.state.view.loadingLayouts = true
        function generateLayouts() {
            let start = new Date().getTime()
            layoutService.list(params).then(function(layoutsConfig) {
                $scope.layoutsConfig = layoutsConfig;
                $scope.expandedLayouts = []
                if (!$scope.expandedLayouts || $scope.expandedLayouts.length == 0) {
                    // TASK [HP] Performance this is slow
                    for (let layoutKey in $scope.layoutsConfig.layouts) {
                        let status = $scope.layoutsConfig.layouts[layoutKey].status
                        for (layout of layoutService.expand($scope.layoutsConfig.layouts[layoutKey], layoutKey, $scope.layoutsConfig.layouts)) {
                            $scope.expandedLayouts.push(Object.assign({}, layout, {status: status}) )
                        }
                    }
                }

                if (!newItem.image) {
                    newItem.image = PLACEHOLDER_IMAGE
                }
                // Keep only overlays settings for current item
                let newTheme = fullcopy($scope.selectedItem.theme);
                try {
                    if ($scope.selectedItem.theme.settings && $scope.selectedItem.theme.settings[$scope.selectedItem.id]) {
                        let settings = $scope.selectedItem.theme.settings[$scope.selectedItem.id]
                        if ($scope.selectedItem.item && $scope.selectedItem.item.overlays && $scope.selectedItem.item.overlays.elements) {
                            let overlayIds = $scope.selectedItem.item.overlays.elements.map(function(element) {
                                return element.uniqueId
                            })
                            if (settings && settings.visual && settings.visual.elements) {
                                for (let elementKey in settings.visual.elements) {
                                    if (overlayIds.indexOf(elementKey) == -1) {
                                        delete settings.visual.elements[elementKey]
                                    }
                                }
                            }
                        }
                        settings = {}
                        newTheme.settings[$scope.selectedItem.id] = settings
                    }
                } catch (e) {
                    logError({
                        message: 'Error while updating settings',
                        error: e
                    })
                }

                if (filtered && filtered.length > 0 && $scope.state.view.layoutTab == 'in-use') {
                    $scope.expandedLayouts = $scope.expandedLayouts.filter(function(layout) {
                        return filtered.indexOf(layout.label) != -1
                    })
                }

                $scope.convertedLayouts = $scope.expandedLayouts.map(function(layout) {
                    let converted = convertLayout(layout, newItem, newTheme)
                    if (layout.status) {
                        converted.status = layout.status
                    }
                    return converted
                })
                let end = new Date().getTime()
                $scope.state.view.loadingLayouts = false
                $scope.renderLayouts()
                $timeout(angular.noop)
                track('Metric Layout Build', {
                    source: 'layouts',
                    time: end - start,
                    count: $scope.convertedLayouts.length
                })
            }).catch(function(error) {
                showError(gettext('error.generic'))
                logError({
                    message: 'Error getting layouts',
                    error: error
                })
            })
            .finally(function() {
                $scope.state.view.loadingLayouts = false
            })
        }
        $timeout(generateLayouts, 10)
    }

    $scope.onChangeLayoutFilter = function() {
        console.log($scope.state.layoutFilter.selected)
        $scope.changeLayouts()
    }


    $scope.renderLayouts = function() {
        if ($scope.mode != 'layout') {
            return
        }
        if (!$scope.convertedLayouts) {
            return
        }
        let filtered = $scope.convertedLayouts.filter(function(item, index) {
            item._originalIndex = index
            return $scope.isLayoutVisible(item, index)
        })
        let paginated = $scope.getArrayForPage(filtered)
        $scope.filteredLayouts = filtered

        if (paginated.length < filtered.length) {
            $scope.state.view.pagination.hasMore = true
        } else {
            $scope.state.view.pagination.hasMore = false
        }
        $scope.availableLayouts = paginated
    }

    $scope.buildPalletes = function() {
        $scope.layoutsConfig.palletes = []
        // Build palletes using HSL
        function fixLimits(value) {
            if (value > 100) {
                value = value - 100
            } else if (value < 0) {
                value = 0
            }
            return value
        }
        let stepsH = 10
        let numberOfColorsPerHue = 4
        let maxSaturation = 130
        let minSaturation = 60
        let hueRange = 360
        for (let h = 0; h < hueRange; h += stepsH) {
            for (let s = 0; s < numberOfColorsPerHue; s++) {
                let saturation = maxSaturation - ((s +1) * minSaturation / (numberOfColorsPerHue - 2))
                saturation = fixLimits(saturation)
                let color = 'hsl(' + h + ', ' + saturation + '%, 50%)'
                // Find best text color (dark or light)
                let text = 'black'
                // Get brightness from HSL
                let brightness = (saturation / 100) * 125
                if (brightness < 125) {
                    text = 'white'
                }
                // LATER - create ligher version of main color (for highlights)
                let mainColorBrightness = (saturation / 100) * 125
                let highlightColor = null


                if (mainColorBrightness < 125) {
                    // Lighter
                    highlightColor = 'hsl(' + h + ', ' + saturation + '%, 80%)'
                } else {
                    // Darker
                    highlightColor = 'hsl(' + h + ', ' + saturation + '%, 20%)'
                }
                $scope.layoutsConfig.palletes.push({
                    main: HSLStringToHex(color),
                    text: HSLStringToHex(text),
                    highlight: HSLStringToHex(highlightColor),
                })
            }
        }

    }

    $scope.changePallete = function() {
        $scope.mode = 'pallete'
        layoutService.list().then(function(layoutsConfig) {
            $scope.layoutsConfig = layoutsConfig;
            $scope.availableLayouts = []

            let newItem = fullcopy($scope.selectedItem.item);
            let theme = $scope.selectedItem.theme
            let updatedLayout = convertLayout($scope.selectedItem.layout, newItem, theme)

            $scope.availableLayouts = [
                updatedLayout
            ]
            $timeout(angular.noop)
        })
        .catch(function(err) {
            logError({
                message: 'Error getting layouts',
                error: err,
            })
        })
    }

    $scope.alignText = function(align, element) {
        $scope.selectedItem.theme.settings[$scope.selectedItem.id][element + 'Align'] = align
        $scope.changeSettings()
        $scope.changeFonts()
    }

    $scope.onChangeApplyBrandKit = function() {
        if ($scope.mode != 'layout') {
            return
        }
        $scope.changeSettings()
        $scope.changeLayouts()
    }

    $scope.onChangeColor = function() {
        if ($scope.mode != 'pallete') {
            return
        }

        let keys = [ 'main', 'text', 'highlight']
        let editedSettings = $scope.tmpEditing.pallete
        initializeSetting($scope.tmpEditingItem.id)
        if ($scope.state.view.editMode == 'multiple') {
            keys.forEach(function(key) {
                $scope.selectedItem.theme.pallete[key] = editedSettings[key]
            })
        } else {
            $scope.selectedItem.theme.settings[$scope.selectedItem.id].pallete = {}
            keys.forEach(function(key) {
                $scope.selectedItem.theme.settings[$scope.selectedItem.id].pallete[key] = editedSettings[key]
            })
        }

        $timeout(angular.noop)

        $scope.changeSettings()
        $scope.changePallete()

        api.updateTheme($scope.currentProject.data.theme, $scope.currentProject._id).catch(function() {
            // TASK - No handling
        })
    }

    $scope.onChangeImageSettings = function() {
        if ($scope.mode != 'images') {
            return
        }
        $scope.changeSettings()
        $scope.changeImages()
    }

    $scope.onChangeFont = function() {
        if ($scope.mode != 'fonts') {
            return
        }
        $scope.changeSettings()
        $scope.changeFonts()
    }

    $scope.onSelectFont = function(font, source) {
        let updatedFonts = {}
        updatedFonts[source] = font
        let eventName = 'selectFonts'

        fontsService.loadCustomOrDefault(font, function() {
            $scope.updateCurrentFontItem()
            $timeout(angular.noop)
        })
        $rootScope.$broadcast(eventName, {
            fonts: updatedFonts,
            selectedItem: $scope.selectedItem
        })

        $scope.showCustomFont = true
    }

    $scope.updateCurrentFontItem = function() {
        let newTheme = fullcopy($scope.selectedItem.theme);
        $scope.availableLayouts[0] = convertLayout($scope.selectedItem.layout, $scope.selectedItem.item, newTheme)
    }

    // The proportion as people know it from Instagram, derived from the height so no size needs a new field
    const SIZE_RATIOS = [[1, '1:1'], [1.25, '4:5'], [4 / 3, '3:4'], [16 / 9, '9:16'], [2 / 3, '3:2']]
    $scope.sizeRatio = function(size) {
        if (!size || !size.width) {
            return ''
        }
        const found = SIZE_RATIOS.find(([height]) => Math.abs(size.height / size.width - height) < 0.01)
        return found ? found[1] : ''
    }

    $scope.changeSizes = function() {
        $scope.mode = 'sizes'
        $scope.resetPagination()
        layoutService.list().then(function(layoutsConfig) {
            $scope.layoutsConfig = layoutsConfig;

            $scope.availableLayouts = $scope.layoutsConfig.sizes.map(function(size) {
                let newTheme = fullcopy($scope.selectedItem.theme);
                newTheme.size = size
                return convertLayout($scope.selectedItem.layout, $scope.selectedItem.item, newTheme)
            })

            $timeout(angular.noop)
        })
        .catch(function(err) {
            logError({
                message: 'Error getting layouts',
                error: err,
            })
        })
    }

    $scope.selectItem = function(object) {
        visual.selectElement({
            elementId: object.uniqueId,
            cardId: $scope.selectedItem.id.toString(),
        })
    }

    $scope.changeContent = function() {
        $scope.mode = 'content'
        layoutService.list().then(function(layoutsConfig) {
            $scope.layoutsConfig = layoutsConfig;

            let newItem = fullcopy($scope.selectedItem.item);
            let theme = $scope.selectedItem.theme
            let updatedLayout = convertLayout($scope.selectedItem.layout, newItem, theme)

            $scope.availableLayouts = [
                updatedLayout
            ]

            $scope.selectContentTab($scope.state.view.content.tab)
        })
        .catch(function(err) {
            logError({
                message: 'Error getting layouts',
                error: err,
            })
        })
    }
    $scope.changeVisual = function() {
        $scope.mode = 'visual'
        layoutService.list().then(function(layoutsConfig) {
            $scope.layoutsConfig = layoutsConfig;

            let newItem = fullcopy($scope.selectedItem.item);
            let theme = $scope.selectedItem.theme
            let updatedLayout = convertLayout($scope.selectedItem.layout, newItem, theme)

            $scope.availableLayouts = [
                updatedLayout
            ]

            $timeout(function() {
                $timeout(function() {
                    if ($scope.visual) {
                        $scope.visual.destroy()
                    }
                    $scope.visual = new visual({})
                    $scope.visual.init({
                        select: function(element) {
                            $scope.state.view.visualMode = null
                            $scope.state.view.showLayers = false

                            $timeout(function() {
                                $scope.state.view.selectedElement = element
                            })
                            $timeout(angular.noop)
                        },
                        deselect: function(element) {
                            console.log('Deselect', element)
                            $timeout(function() {
                                $scope.state.view.selectedElement = false
                            })
                        },
                        update: function(change) {
                            if (change && change.values && change.values.content && $scope.selectedItem.item && $scope.selectedItem.item.overlays && $scope.selectedItem.item.overlays.elements) {
                                // Find element within overlay and update its value witht content
                                let overlayElements = $scope.selectedItem.item.overlays.elements
                                let element = overlayElements.find(function(element) {
                                    return element.uniqueId == change.elementId
                                })
                                if (element) {
                                    element.value = change.values.content
                                }
                            }
                            $scope.changeSettings()
                            $timeout(angular.noop)
                        },
                        render: function() {
                            console.log('Render')
                            $scope.refreshVisual()
                        }
                    }, $scope.selectedItem, {
                        wrapperSelector: '.visual-wrapper',
                    })
                })
            })
        })
        .catch(function(err) {
            logError({
                message: 'Error getting layouts',
                error: err,
            })
        })
    }

    $scope.changeBackgrounds = function() {
        $scope.mode = 'backgrounds'
        layoutService.overlays().then(function(overlays) {
            $scope.overlaysConfig = overlays

            let targetArea = convertLayout($scope.selectedItem.layout, $scope.selectedItem.item, $scope.selectedItem.theme)

            $scope.availableLayouts = overlays.map(function(overlayConfig) {
                let overlay = fullcopy(overlayConfig)
                let updated = visual.replaceOverlays($scope.selectedItem, overlay, 'background-overlay-')
                return convertLayout($scope.selectedItem.layout, updated.item, updated.theme)
            })
            $timeout(angular.noop)
        })
    }

    $scope.isAutoFontSize = function() {
        if (!$scope.selectedItem) {
            return true
        }
        if (!$scope.selectedItem.theme) {
            return true
        }
        if (!$scope.selectedItem.theme.settings) {
            return true
        }
        if (!$scope.selectedItem.theme.settings[$scope.selectedItem.id]) {
            return true
        }
        if (typeof $scope.selectedItem.theme.settings[$scope.selectedItem.id].autoFontSize == 'undefined') {
            return true
        }
        return $scope.selectedItem.theme.settings[$scope.selectedItem.id].autoFontSize
    }

    $scope.resetPagination = function() {
        $scope.state.view.pagination.page = 1
        $scope.state.view.pagination.hasMore = false
    }

    $scope.getArrayForPage = function(data) {
        let start = 0
        let end = start + $scope.state.view.pagination.page * $scope.state.view.pagination.limit
        return data.slice(start, end)
    }

    $scope.changeFontSize = function() {
        $scope.mode = 'font-size'
        $scope.renderSinglePreview()
    }

    $scope.changeFonts = function() {
        $scope.mode = 'fonts'
        $scope.resetPagination()

        function getFont(id) {
            if (!id) {
                return null
            }

            let name = fontsService.getFontName(id)

            return {
                label: name,
                value: id
            }
        }
        let primaryFont = getFont($scope.selectedItem.theme.fonts.primary)
        let secondaryFont = getFont($scope.selectedItem.theme.fonts.secondary)

        let fonts = JSON.parse(JSON.stringify(DEFAULT_FONTS))
        fonts = fonts.filter(function(font) {
            return font.value != primaryFont.value && font.value != secondaryFont.value
        })

        // Add primary and secondary fonts to beginning
        if (primaryFont) {
            fonts.unshift(primaryFont)
        }
        if (primaryFont && secondaryFont && secondaryFont.value != primaryFont.value) {
            fonts.unshift(secondaryFont)
        }

        $scope.state.data.fonts = fonts

        $scope.renderFonts()
    }

    $scope.renderFonts = function() {
        const USE_LAYOUTS = $scope.state.view.selection.fonts
        layoutService.list().then(function(layoutsConfig) {
            $scope.layoutsConfig = layoutsConfig;
            let fontsToLoad = new Set()
            let availableLayouts = []

            if (USE_LAYOUTS) {
                let newTheme = fullcopy($scope.selectedItem.theme);
                if ($scope.state.view.pagination.page == 1) {
                    availableLayouts.push(convertLayout($scope.selectedItem.layout, $scope.selectedItem.item, newTheme))
                }

                let currentPageFonts = $scope.getArrayForPage($scope.layoutsConfig.fonts)
                $scope.state.view.pagination.hasMore = currentPageFonts.length < $scope.layoutsConfig.fonts.length
                let fontsCombinations = currentPageFonts.map(function(fonts) {
                    let newTheme = fullcopy($scope.selectedItem.theme);
                    newTheme.fonts = fonts
                    fontsToLoad.add(fonts.primary)
                    fontsToLoad.add(fonts.secondary)
                    return convertLayout($scope.selectedItem.layout, $scope.selectedItem.item, newTheme)
                })
                availableLayouts = availableLayouts.concat(fontsCombinations)
                $scope.availableLayouts = availableLayouts
            } else {
                let newTheme = fullcopy($scope.selectedItem.theme);
                if ($scope.state.view.pagination.page == 1) {
                    availableLayouts.push(convertLayout($scope.selectedItem.layout, $scope.selectedItem.item, newTheme))
                }
                let currentPageFonts = $scope.getArrayForPage($scope.layoutsConfig.fonts)
                $scope.state.view.pagination.hasMore = currentPageFonts.length < $scope.layoutsConfig.fonts.length
                $scope.availableLayouts = availableLayouts

                $scope.state.combinations.fonts = currentPageFonts.map(function(fonts) {
                    fontsToLoad.add(fonts.primary)
                    fontsToLoad.add(fonts.secondary)
                    return fonts
                })
            }
            $scope.showFontSelection = true
            fontsService.load(Array.from(fontsToLoad))
            $scope.fontFamilies = fontsService.updateFontFamilies(fontsToLoad)
            $timeout(angular.noop)
        })
        .catch(function(err) {
            logError({
                message: 'Error getting layouts',
                error: err,
            })
        })
    }

    $scope.showLoadMore = function() {
        return $scope.state.view.pagination.hasMore && ($scope.mode == 'layout' || $scope.mode == 'fonts')
    }

    $scope.loadMore = function() {
        $scope.state.view.pagination.page += 1
        $scope.state.view.loadingMore = true
        if ($scope.mode == 'fonts') {
            $scope.renderFonts()
        } else if ($scope.mode == 'layout') {
            $scope.renderLayouts()
        }
        $timeout(function() {
            $scope.state.view.loadingMore = false
        }, 300)
    }

    $scope.onScroll = function() {
        if ($scope.state.view.loadingMore) {
            return
        }
        $scope.loadMore()
    }


    $scope.changeImageTab = function(tab) {
        $scope.state.view.imageTab = tab
        track('Editor Image Tab', {
            tab: tab
        })
    }

    $scope.selectMedia = function(media, kind) {
        let baseMedias = []
        if (kind == 'user') {
            baseMedias = $scope.medias
        } else if (kind == 'pexels') {
            baseMedias = $scope.state.images.pexels
        }
        // Inactivate all other items
        baseMedias.forEach(function(media) {
            media.active = false
        })
        media.active = true
        let eventName = 'selectImages'
        $scope.selectedItem.item.image = media.data.url
        $rootScope.$broadcast(eventName, {
            applySingle: true,
            image: media.data.url,
            selectedItem: $scope.selectedItem
        })
    }

    $scope.onSelectMedia = function(media) {
        console.log('Media', media)
        let eventName = 'selectImages'
        $scope.selectedItem.item.image = media.data.url
        $rootScope.$broadcast(eventName, {
            applySingle: true,
            image: media.data.url,
            selectedItem: $scope.selectedItem
        })
    }

    $scope.requestSearchIcons = function(query) {
        return $http.get(window.BASE_URL + '/api/creator/icons/search', {
            params: {
                query: $scope.search.icons
            }
        })
    }

    $scope.changeImages = function() {
        $scope.mode = 'images'
    }

    $scope.selectSearchIcon = function(item) {
        $scope.search.icons = item.value
        $scope.searchIcons()
        track('Visual Search Icons', {
            query: item.value,
            type: 'suggested'
        })
    }

    $scope.searchIcons = function(trackEvent=true) {
        $scope.state.view.iconLoading = true
        $scope.requestSearchIcons($scope.search.icons).then(function(response) {
            $scope.icons = response.data
        })
        .finally(function() {
            $scope.state.view.iconLoading = false
        })
        if (!trackEvent) {
            return
        }
        track('Visual Search Icons', {
            query: $scope.search.icons,
        })
    }

    $scope.changeIcons = function() {
        $scope.mode = 'icons'
        $scope.requestSearchIcons().then(function(response) {
            let icons = response.data.map(function(photo) {
                return photo.preview_url
            })
            $scope.icons = icons
            layoutService.list().then(function(layoutsConfig) {
                $scope.layoutsConfig = layoutsConfig;
                $scope.availableLayouts = icons.map(function(icon) {
                    let newItem = fullcopy($scope.selectedItem.item);
                    // LATER - Forward
                    newItem.icons = [icon]
                    return parserService.convertLayout($scope.selectedItem.layout, newItem, $scope.selectedItem.theme)
                })
                $timeout(angular.noop)
            })
            .catch(function(err) {
                logError({
                    message: 'Error getting layouts',
                    error: err,
                })
            })
        })
    }

    $scope.updateOverlays = function() {
        $rootScope.$broadcast('updateOverlays', {
            overlays: $scope.selectedItem.item.overlays,
            selectedItem: $scope.selectedItem
        })
    }

    $scope.changeSettings = function() {
        $rootScope.$broadcast('updateSettings', {
            settings: $scope.selectedItem.theme.settings[$scope.selectedItem.id],
            selectedItem: $scope.selectedItem
        })
    }

    $scope.isFilterVisible = function(category) {
        return $scope.noFilterCategories.indexOf(category) == -1
    }

    $scope.isLayoutVisible = function(layout, $index) {
        if ($scope.mode != 'layout') {
            return true
        }
        if ($scope.state.view.layoutTab == 'favorite') {
            return $scope.favorites.map && $scope.favorites.map[layout.label]
        }
        if ($scope.state.view.layoutTab != 'default') {
            return true
        }
        let hasNumber = $scope.selectedItem.item.number && $scope.selectedItem.item.number != ''
        // Check if layout categories include number
        if (!hasNumber && layout.categories.indexOf('number') != -1) {
            return false
        }
        let isAllActive = $scope.availableTags.filter(function(tag) {
            return tag.id == 'all' && tag.active
        }).length > 0

        if (!isAllActive) {
            let layoutTags = layout.tags || []
            let selectedTags = $scope.availableTags.filter(function(tag) {
                return tag.active
            }).map(function(tag) {
                return tag.id
            })

            function isMixedLayout(layout) {
                return layout.label.indexOf('mixed') != -1
            }
            function shouldInclude(selectedTags) {
                return selectedTags.every(tag => layoutTags.includes(tag) || (tag == 'base' && !isMixedLayout(layout)))
            }

            if (!isAllActive && !shouldInclude(selectedTags)) {
                return false
            }
        }

        if ($scope.state.view.category == 'all') {
            if (!$scope.expandedLayouts[$index]) {
                return false
            }
            if (!layoutService.filter($scope.expandedLayouts[$index], $scope.selectedItem.item)) {
                return false
            }
            return true
        }
        if (!layout.categories || layout.categories.length == 0) {
            return false
        }
        if (layout.categories.indexOf($scope.state.view.category) == -1) {
            return false
        }
        if (!$scope.expandedLayouts[$index]) {
            return false
        }
        if (!layoutService.filter($scope.expandedLayouts[$index], $scope.selectedItem.item)) {
            return false
        }
        return true
    }

    $scope.changeLayoutTab = function(tab) {
        $scope.state.view.layoutTab = tab
        if (tab == 'explore' || tab == 'user' || tab == 'children' || tab == 'favorite') {
            $scope.state.view.category = 'all'
        } else {
            $scope.state.view.category = 'cover'
        }
        $scope.changeLayouts()
        $scope.getFavorites()
    }

    $scope.changeCategory = function(category) {
        $scope.state.view.category = category
        track('Editor Category Select', {
            category: category
        })

        // TODO - Remove from here
        let shouldLayoutsWithMedias = false
        if (shouldLayoutsWithMedias) {
            let medias = []
            api.getMedias({kind: 'image', meta: true}).then(function(response) {
                $timeout(function() {
                    medias = response.data

                    let widgetLayouts = $scope.expandedLayouts.filter(function(layout) {
                        return layout.label.indexOf('widgets') != -1
                    })
                    let mapLabelLayout = {}
                    widgetLayouts.forEach(function(layout) {
                        mapLabelLayout[layout.label] = layout
                    })
                    /*"widgets.main.rest-bottom-element-bottom
                    "widgets.main.rest-right-element-bottom"
                    "widgets.main.rest-right-element-right-att-bottom"
                    "widgets.main.rest-right-element-right-att-center"*/

                    let newTheme = fullcopy($scope.selectedItem.theme);
                    newTheme.settings[$scope.selectedItem.id] = {}

                    let convertedLayouts = []
                    let expandedLayouts = []
                    medias.map(function(media) {
                        let meta = media.meta

                        // Ignore for now
                        if (meta.attachment.top || meta.attachment.left) {
                            return
                        }

                        let selectedLayoutLabel = 'widgets.main.rest-right-element-right-att-center'
                        if (meta.aspect.kind == 'portrait') {
                            selectedLayoutLabel = 'widgets.main.rest-right-element-right-att-bottom'
                        } else if (meta.aspect.kind == 'landscape') {
                            selectedLayoutLabel = 'widgets.main.rest-bottom-element-bottom'
                        }

                        // Check attachment
                        let newItem = fullcopy($scope.selectedItem.item);
                        let layout = fullcopy(mapLabelLayout[selectedLayoutLabel])
                        newItem.image = media.data.url

                        let convertedLayout = convertLayout(layout, newItem, newTheme)
                        convertedLayouts.push(convertedLayout)
                        expandedLayouts.push(layout)
                    })

                    $scope.convertedLayouts = convertedLayouts
                    $scope.expandedLayouts = expandedLayouts

                    $scope.renderLayouts()

                    console.log('Medias', medias, widgetLayouts.map(function(layout) {
                        return layout.label
                    }))
                })
            })
            return
        }

        if ($scope.noFilterCategories.indexOf(category) != -1) {
            let baseTag = $scope.availableTags.find(tag => tag.id == 'base')
            if (!baseTag.active) {
                $scope.toggleTag(baseTag)
            }
        }
    }

    $scope.toggleFavoriteLayout = function($index) {
        let layout = $scope.availableLayouts[$index]
        if (!layout) {
            showError(gettext('error.generic'))
            return
        }
        if (!$scope.state.view.projectId) {
            showError(gettext('error.generic'))
            return
        }
        let id = layout.label
        if ($scope.favorites.map[layout.label]) {
            api.removeFavorite({
                kind: 'layout',
                value: id,
                projectId: $scope.state.view.projectId
            }).then(function() {
                delete $scope.favorites.map[layout.label]
                showSuccess(gettext('label.success_generic'))
            })
            .catch(function() {
                showError(gettext('error.generic'))
            })
            .finally(function() {
                $timeout(angular.noop)
            })
        } else {
            let fullLayout = $scope.expandedLayouts[$index]
            let addParams = {
                kind: 'layout',
                value: id,
                projectId: $scope.state.view.projectId
            }
            if (id.startsWith('s-')) {
                addParams.layout = fullLayout
            }
            api.addFavorite(addParams).then(function() {
                $scope.favorites.map[layout.label] = true
                showSuccess(gettext('label.success_generic'))
            })
            .catch(function() {
                showError(gettext('error.generic'))
            })
            .finally(function() {
                $timeout(angular.noop)
            })
        }
    }

    $scope.selectChange = function(index, kind) {
        if ($scope.mode == 'visual') {
            return
        }
        let eventName = 'select' + $scope.mode.charAt(0).toUpperCase() + $scope.mode.slice(1)
        if ($scope.mode == 'pallete') {
            $rootScope.$broadcast(eventName, {
                pallete: $scope.layoutsConfig.palletes[index],
                selectedItem: $scope.selectedItem
            })
        } else if ($scope.mode == 'sizes') {
            $rootScope.$broadcast(eventName, {
                size: $scope.layoutsConfig.sizes[index],
                selectedItem: $scope.selectedItem
            })
        }
        else if ($scope.mode == 'fonts') {
            if (index > 0) {
                $rootScope.$broadcast(eventName, {
                    fonts: $scope.layoutsConfig.fonts[index-1],
                    selectedItem: $scope.selectedItem
                })
                $scope.showCustomFont = false
            }
            $scope.updateCurrentFontItem()
        }
        else if ($scope.mode == 'layout') {
            let originalIndex = $scope.filteredLayouts[index]._originalIndex
            let selectedLayout = $scope.expandedLayouts[originalIndex]
            console.log('Selected layout', selectedLayout.label)

            if ($scope.detachedSelection) {
                $rootScope.$broadcast('layouts.choose', {
                    source: $scope.detachedSelection.source,
                    layout: selectedLayout,
                })
                $scope.detachedSelection = null
                let layoutsModal = angular.element('#layouts-modal')
                layoutsModal.modal('hide')
                return
            }

            function updateLayoutsInUse(label) {
                $scope.state.view.layoutsInUse = $scope.state.view.layoutsInUse || []
                $scope.state.view.layoutsInUse = Array.from(new Set($scope.state.view.layoutsInUse.concat([label])))
            }

            updateLayoutsInUse(selectedLayout.label)

            if (kind) {
                $rootScope.$broadcast('applyLayoutMultiplePages', {
                    layout: selectedLayout,
                    pages: kind,
                    page: $scope.selectedItem.id,
                })
                return
            }
            $scope.selectedItem.layout = selectedLayout

            $rootScope.$broadcast(eventName, {
                layout: $scope.expandedLayouts[originalIndex],
                selectedItem: $scope.selectedItem
            })
            $scope.loadLayoutChildren($scope.selectedItem.layout)

            $scope.availableLayouts.forEach(function(layout) {
                layout.active = false
            })
            $scope.availableLayouts[index].active = true

            if ($scope.state.view.layoutTab != 'children' && $scope.state.view.layoutTab != 'user' && $scope.state.view.layoutTab != 'explore') {
                return
            }

            if (getLayoutParentId($scope.selectedItem.layout)) {
                // If not applyRotation, set to false
                if (!$scope.selectedItem.theme.global) {
                    $scope.selectedItem.theme.global = {}
                }
                if (typeof $scope.selectedItem.theme.global.applyRotation == 'undefined') {
                    $scope.selectedItem.theme.global.applyRotation = false
                }
            }
            // TODo - this is bugged
            if ($scope.selectedItem.layout.brandKit) {
                if (!$scope.selectedItem.theme.global) {
                    $scope.selectedItem.theme.global = {}
                }
                $scope.selectedItem.theme.global.brandKit = $scope.selectedItem.layout.brandKit
                $scope.changeSettings()
            } else {
                if ($scope.selectedItem.theme.global && $scope.selectedItem.theme.global.brandKit) {
                    delete $scope.selectedItem.theme.global.brandKit
                }
            }

            if ($scope.selectedItem.id == 0 && getLayoutParentId($scope.selectedItem.layout)) {
                $rootScope.$broadcast('applyThemeToAllPages', {
                    layout: $scope.selectedItem.layout
                })
            }
        } else if ($scope.mode == 'images') {
            $scope.selectedItem.item.image = $scope.images[index]
            $rootScope.$broadcast(eventName, {
                applySingle: true,
                image: $scope.images[index],
                selectedItem: $scope.selectedItem
            })
        } else if ($scope.mode == 'icons') {
            $scope.selectedItem.icons = [$scope.icons[index]]
            $rootScope.$broadcast(eventName, {
                applySingle: true,
                icons: [$scope.icons[index]],
                selectedItem: $scope.selectedItem
            })
        } else if ($scope.mode == 'backgrounds') {
            let overlay = fullcopy($scope.overlaysConfig[index])
            let updated = visual.replaceOverlays($scope.selectedItem, overlay, 'background-overlay-')
            $scope.selectedItem.item = updated.item
            $scope.selectedItem.theme = updated.theme
            $scope.changeSettings()
            $rootScope.$broadcast(eventName, {
                applySingle: true,
                overlays: updated.item.overlays,
                selectedItem: $scope.selectedItem
            })
        }
        // Inactivate all other items
        $scope.availableLayouts.forEach(function(layout) {
            layout.active = false
        })
        if ($scope.availableLayouts[index]) {
            $scope.availableLayouts[index].active = true
        }

        track('Editor Layout Select', {
            mode: $scope.mode,
        })
    }

    $scope.refreshVisual = function() {
        $timeout(function() {
            $scope.changeVisual()
            $scope.changeSettings()
            $scope.updateOverlays()
            $scope.updateLayers()
        })
    }

    $scope.resetVisualLayout = function() {
        let ids = []

        if ($scope.selectedItem.item.overlays && $scope.selectedItem.item.overlays.elements) {
            $scope.selectedItem.item.overlays.elements.forEach(function(element) {
                ids.push(element.uniqueId)
            })
        }
        visual.resetVisualLayout($scope.selectedItem.theme, $scope.selectedItem.id, {
            'exclude': ids
        })
        $scope.refreshVisual()
    }

    $scope.updateContentLayers = function() {
        let layers = []
        let type = $scope.state.view.content.tab

        let mapTypes = {
            'text': ['p', 'h1'],
            'image': ['image'],
        }

        let replacedMapIds = {}

        let ignoreVariables = [
            'title',
            'description',
            'author.handle',
            'image',
        ]
        let hideVariables = [
            'title',
            'description',
        ]
        function getIdsWithReplace(tree) {
            for (let element of tree.elements) {
                // TODO - Not supported yet
                for (let ignore of ignoreVariables) {
                    if (element.replace == ignore && $scope.selectedItem.item[ignore]) {
                        replacedMapIds[element.id] = true
                    }
                    // Deal with variables that have multiple .
                    if (element.replace == 'author.handle' && $scope.selectedItem.item.author && $scope.selectedItem.item.author.handle) {
                        replacedMapIds[element.id] = true
                    }
                }
                for (let hide of hideVariables) {
                    if (element.replace == hide) {
                        replacedMapIds[element.id] = true
                    }
                }
                if (element.elements) {
                    getIdsWithReplace(element)
                }
            }
        }
        getIdsWithReplace($scope.selectedItem.layout)

        function getLayers(tree) {
            for (let element of tree.elements) {
                if (mapTypes[type].includes(element.type)) {
                    if (element.type === 'p' || element.type === 'h1') {
                        // TODO - support replace values
                        if (element.value && !replacedMapIds[element.id]) {
                            layers.push(element)
                        }
                    }
                    else if (element.type === 'image' && element.src) {
                        layers.push(element)
                    }
                }
                if (element.elements) {
                    getLayers(element)
                }
            }
        }

        // Do not use original to void double changing
        getLayers(JSON.parse(JSON.stringify($scope.selectedItem.layout)))
        $scope.state.view.content.currentLayers = layers
    }

    $scope.shouldShowContentTab = function() {
        return $scope.selectedItem && $scope.selectedItem.layout && $scope.selectedItem.layout.label && $scope.selectedItem.layout.label.startsWith('d-')
    }

    $scope.updateLayerValue = function(params) {
        if (!params.id || !params.content) {
            return
        }

        function updateValue(id, value) {
            // find element in selected item.layout
            function findElement(tree) {
                for (let element of tree.elements) {
                    if (element.id == id) {
                        return element
                    }
                    if (element.elements) {
                        let found = findElement(element)
                        if (found) {
                            return found
                        }
                    }
                }
                return null
            }
            let element = findElement($scope.selectedItem.layout)
            if (element) {
                if (element.type == 'image') {
                    if (!element.originalValue && element.src) {
                        element.originalValue = element.src
                    }
                    element.src = value
                } else {
                    if (!element.originalValue && element.value) {
                        element.originalValue = element.value
                    }
                    element.value = value
                }
            }
        }

        function renderContent() {
            let newItem = fullcopy($scope.selectedItem.item);
            let theme = $scope.selectedItem.theme
            let updatedLayout = convertLayout($scope.selectedItem.layout, newItem, theme)

            $scope.availableLayouts = []
            $scope.availableLayouts = [
                updatedLayout
            ]
        }

        updateValue(params.id, params.content)

        $rootScope.$broadcast('selectLayout', {
            layout: $scope.selectedItem.layout,
            selectedItem: $scope.selectedItem
        })
        renderContent()
        $timeout(angular.noop)
    }

    $rootScope.$on('media.selected', function(event, medias, source) {
        if (source && source.origin != 'layout') {
            return
        }
        if ($scope.mode == 'content' && source.name == 'content') {
            $scope.updateLayerValue(
                {
                    id: $scope.state.view.content.selectedLayer.id,
                    content: medias[0].url
                }
            )

            $scope.selectContentTab('image')
        }
        if (source && source.name == 'font') {
            let fontKey = medias[0].url.split('/').pop()
            let fontName = medias[0].name

            if ($scope.state.data.fonts.filter(font => font.value == fontKey).length == 0) {
                $scope.state.data.fonts.unshift({
                    label: fontName,
                    value: fontKey
                })
            }
            $scope.onSelectFont(fontKey, source.kind)
        }
    })

    $scope.changeContentImage = function(layer) {
        $scope.state.view.content.selectedLayer = layer
        $scope.showMediaSelector('content')
    }

    $scope.showMediaSelector = function(source, kind) {
        modalElement = angular.element('#images-modal');
        if (modalElement) {
            modalElement.modal('show')
            modalElement.css('z-index', 100000)

            if (typeof source == 'string') {
                source = {
                    name: source,
                }
            }
            source.origin = 'layout'

            $rootScope.$broadcast('media.show', {
                source: source,
                projectId: $scope.state.view.projectId,
                kind: kind ? kind : 'image',
            })
        }
    }

    $scope.selectCustomFont = function(kind) {
        $scope.showMediaSelector({
            origin: 'layout',
            name: 'font',
            kind: kind
        }, 'font')
    }

    $scope.resetContentLayer = function(layer) {
        if (!layer.originalValue) {
            return
        }
        $scope.updateLayerValue(
            {
                id: layer.id,
                content: layer.originalValue
            }
        )
        $scope.updateContentLayers()
    }

    $scope.selectContentTab = function(tab) {
        $scope.state.view.content.tab = tab
        $scope.updateContentLayers()
    }

    $scope.selectContentLayer = function() {
    }

    $scope.init = function() {
        $scope.search.icons = $scope.suggestedSearchIcons[0].value
        $scope.searchIcons(trackEvent=false)

        // TODO - improve
        $scope.getCategories()
    }

    $scope.getFavorites = function() {
        if ($scope.favorites.layouts && $scope.favorites.layouts.length > 0) {
            return
        }
        if (!$scope.state.view.projectId) {
            return
        }
        api.getFavorites($scope.state.view.projectId).then(function(response) {
            if (!response.data || !response.data.data || !response.data.data.data || !response.data.data.data.layout) {
                return
            }
            $scope.favorites.layouts = response.data.data.data.layout
            $scope.favorites.map = {}
            $scope.favorites.layouts.forEach(function(layout) {
                $scope.favorites.map[layout.key] = true
            })
        })
        .catch(function(err) {
            logError({
                message: 'Error getting favorites',
                error: err,
            })
        })
    }

    /* Visual Mode */
    $scope.toggleDetailedMode = function(kind) {
        for (let key in $scope.state.view.visual) {
            if (key == kind) {
                continue
            }
            $scope.state.view.visual[key] = false
        }
        $scope.state.view.visual[kind] = !$scope.state.view.visual[kind]
    }

    $scope.toggleVisualMode = function(mode) {
        $scope.state.view.visualMode = mode
    }

    $scope.hideVisualMode = function() {
        $scope.state.view.visualMode = null
        $scope.state.view.showLayers = false
        // Reset all detailed modes
        for (let key in $scope.state.view.visual) {
            $scope.state.view.visual[key] = false
        }
        $scope.visual.deselectElement()
    }

    $scope.addText = function(kind) {
        $scope.visual.addText(kind)
        $scope.hideVisualMode()
    }

    $scope.addImage = function(image) {
        $scope.showMediaSelector('createImage')
    }

    $scope.addIcon = function(icon) {
        let url = icon.svg_url
        $scope.state.view.iconLoading = true
        $http.get(url).then(function(response) {
            $scope.hideVisualMode()
            visual.addElement(response.data)
        }).finally(function() {
            $scope.state.view.iconLoading = true
        })
    }

    $scope.updateLayers = function() {
        function getLayers(layout) {
            let layers = []
            if (layout.elements) {
                layout.elements.forEach(function(element) {
                    if (element.id.indexOf('background') != -1) {
                        return
                    }
                    if (element.type != 'container' && element.type != 'clipPath') {
                        let value = element.value
                        if (element.type == 'overlay' || element.type == 'svg') {
                            value = ''
                        } else if (value && value.length > 30) {
                            value = value.substring(0, 30) + '...'
                        }
                        layers.push({
                            uniqueId: element.id,
                            name: gettext('elements.' + element.type),
                            value: value,
                        })
                    }
                    if (element.elements) {
                        layers = layers.concat(getLayers(element))
                    }
                })
            }
            return layers
        }

        let newItem = fullcopy($scope.selectedItem.item);
        let theme = $scope.selectedItem.theme
        let updatedLayout = convertLayout($scope.selectedItem.layout, newItem, theme)

        $scope.state.view.layers = getLayers(updatedLayout)
    }

    $scope.toggleLayers = function() {
        $scope.state.view.showLayers = !$scope.state.view.showLayers
        $scope.state.view.visualMode = $scope.state.view.showLayers ? 'layers' : null
        $scope.updateLayers()
    }
})
